module.exports = __webpack_public_path__ + "img/lengquefa-off.19583b99.png";